// extracted by mini-css-extract-plugin
export default {"wrapperModalChangePass":"CustomModalClose_wrapperModalChangePass__tN2Hy","container":"CustomModalClose_container__GhD7x"};